import styled from '@emotion/styled';

export const QuickPickWrapper = styled('section', { label: 'QuickPickWrapper' })`
    color: #585b5a;
    position: relative;
`;
